__webpack_require__.p = "https://certificate.quantstamp.com/full/tac-yieldfi-proxy/59390847-c874-4e7c-a1aa-684a4d4be18a/";